module.exports = __webpack_public_path__ + "img/stop-button.894f3610.png";